"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptNotificationHandler = acceptNotificationHandler;
var _acceptNotificationFailed = require("@ori-events/accept-notification-failed");
var _types = require("../types");
var _utils = require("../utils");
async function acceptNotificationHandler({
  detail: {
    reasonId
  }
}) {
  const response = await fetch(`${_types.RequestUrl.AcceptNotification}?reasonId=${reasonId}`);
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if ((0, _acceptNotificationFailed.isAcceptNotificationErrorResponse)(data)) {
    const errorEvent = new CustomEvent(_acceptNotificationFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}